import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "../Sidebar";
import { Header } from "../Header";
import Banner from "../components/Banner";
import SliderContainer from "../components/SliderContainer";
import { Footer } from "../Footer";


const LiveCasino = () => {
  const [isSidebar, setSidebar] = useState(false);
  const liveCasinoGames=[
    {
      src: "https://ossimg.envyenvelope.com/daman/vendorlogo/vendorlogo_20240508160218vghg.png",
      name: "MG Grand Live Casino",
      GAMEID:
        "936651bfd3aeb789d957f4393078367a",
      provider:
        "Evolution",
    },
    {
      src: "https://ossimg.91admin123admin.com/91club/vendorlogo/vendorlogo_202401021635413lly.png",
      name: "Sexy Casino",
      GAMEID:
        "3630a6a3c836afa6864578ef21f8fa93",
      provider:
        "Evolution",
    },
    {
      src: "https://ossimg.91admin123admin.com/91club/vendorlogo/vendorlogo_20240102164947dvuc.png",
      name: "United Gaming",
      GAMEID:
        "c4b2813f6bbc5abf502ddfb857e604eb",
      provider:
        "Evolution",
    },
    {
        src: "https://ossimg.envyenvelope.com/daman/vendorlogo/vendorlogo_20240508160218vghg.png",
        name: "MG Grand Live Casino",
        GAMEID:
          "936651bfd3aeb789d957f4393078367a",
        provider:
          "Evolution",
      },
      {
        src: "https://ossimg.91admin123admin.com/91club/vendorlogo/vendorlogo_202401021635413lly.png",
        name: "Sexy Casino",
        GAMEID:
          "3630a6a3c836afa6864578ef21f8fa93",
        provider:
          "Evolution",
      },
      {
        src: "https://ossimg.91admin123admin.com/91club/vendorlogo/vendorlogo_20240102164947dvuc.png",
        name: "United Gaming",
        GAMEID:
          "c4b2813f6bbc5abf502ddfb857e604eb",
        provider:
          "Evolution",
      },
  ]

  const casinoGames= [
    {
      name: "Dragon & Tiger",
      GAMEID: "dc76761a9dd2b423da6df25a6b65eab1",
      "game_type": "Table Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dragon-&-Tiger.png",
      provider: "jili"
    },
    {
      name: "7 UP-DOWN",
      GAMEID: "f897d3bfa4061b602cd0ce1d1ea88312",
      "game_type": "Table Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/7-UP-DOWN.png",
      provider: "jili"
    },
    {
      name: "Poker King",
      GAMEID: "a9b13010273fcb0284c9ef436c5fe2ff",
      "game_type": "Table Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Poker-King.png",
      provider: "jili"
    },
    {
      name: "7up7down",
      GAMEID: "3aca3084a5c1a8c77c52d6147ee3d2ab",
      "game_type": "Table Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/7up7down.png",
      provider: "jili"
    },
    {
      name: "Baccarat",
      GAMEID: "b9c7c5f589cdaa63c4495e69eaa6dbbf",
      "game_type": "Table Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Baccarat.png",
      provider: "jili"
    },
    {
      name: "Fortune Bingo",
      GAMEID: "2fd70535a3c838a438b4b8003ecce49d",
      "game_type": "Table Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fortune-Bingo.png",
      provider: "jili"
    },
  ];

  const RummyGames=[
    {
      name: "TeenPatti",
      GAMEID: "f743cb55c2c4b737727ef144413937f4",
      "game_type": "India Poker Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/TeenPatti.png",
      provider: "jili"
    },
    {
      name: "AK47",
      GAMEID: "488c377662cad37a551bde18e2fbe785",
      "game_type": "India Poker Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/AK47.png",
      provider: "jili"
    },
    {
      name: "Andar Bahar",
      GAMEID: "6f48b3aa0b64c79a2dc320ea021148b5",
      "game_type": "India Poker Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Andar-Bahar.png",
      provider: "jili"
    },
    {
      name: "Rummy",
      GAMEID: "ae632f32c3a1e6803f9a6fbec16be28e",
      "game_type": "India Poker Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Rummy.png",
      provider: "jili"
    },
    {
      name: "Callbreak",
      GAMEID: "9092b5a56e001c60850c4c1184c53e07",
      "game_type": "India Poker Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Callbreak.png",
      provider: "jili"
    },
    {
      name: "TeenPatti Joker",
      GAMEID: "1a4eaca67612e65fdcae43f4c8a667a4",
      "game_type": "India Poker Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/TeenPatti-Joker.png",
      provider: "jili"
    },
    {
      name: "Callbreak Quick",
      GAMEID: "aa9a9916d6e48ba50afa3c2246b6dacb",
      "game_type": "India Poker Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Callbreak-Quick.png",
      provider: "jili"
    },
    {
      name: "TeenPatti 20-20",
      GAMEID: "1afa7db588d05de7b9abca4664542765",
      "game_type": "India Poker Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/TeenPatti-20-20.png",
      provider: "jili"
    },
    {
      name: "Ludo Quick",
      GAMEID: "bb1f14d788d37b06dc8f6701ed57ed0d",
      "game_type": "India Poker Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Ludo-Quick.png",
      provider: "jili"
    },
    {
      name: "Tongits Go",
      GAMEID: "26fbfab92a3837b7dbf767e783b173af",
      "game_type": "India Poker Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Tongits-Go.png",
      provider: "jili"
    },
    {
      name: "Pusoy Go",
      GAMEID: "f2879a3f20f305eadad13448e11c052e",
      "game_type": "India Poker Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Pusoy-Go.png",
      provider: "jili"
    },
    {
      name: "Blackjack",
      GAMEID: "3b502aee6c9e1ef0f698332ee1b76634",
      "game_type": "India Poker Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Blackjack.png",
      provider: "jili"
    },
    {
      name: "Blackjack Lucky Ladies",
      GAMEID: "d0d1c20062e28493e1750f27a1730c48",
      "game_type": "India Poker Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Blackjack-Lucky-Ladies.png",
      provider: "jili"
    },
    {
      name: "MINI FLUSH",
      GAMEID: "07afefc388ab6af8cf26f85286f83fae",
      "game_type": "India Poker Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/MINI-FLUSH.png",
      provider: "jili"
    },
    {
      name: "Pool Rummy",
      GAMEID: "43e7df819bf57722a8917bb328640b30",
      "game_type": "India Poker Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Pool-Rummy.png",
      provider: "jili"
    },
    {
      name: "Caribbean Stud Poker",
      GAMEID: "04c9784b0b1b162b2c86f9ce353da8b7",
      "game_type": "India Poker Game",
      src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Caribbean-Stud-Poker.png",
      provider: "jili"
    },
  ];

  useEffect(() => {
    window.scrollTo(0,0);
    const handleResize = () => {
      // Start closed and let the visitor open it. Forcing it open
      // above 991px put a fixed panel over the page content.
      setSidebar(false);
    };

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Initial check to set the correct sidebar state
    handleResize();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16">
      <div _ngcontent-jrx-c101="">
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">
            <div _ngcontent-jrx-c95="" className="body-container">
              <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  width: isSidebar ? "" : "100%",
                  transition: "width 0.3s ease-in-out",
                }}
              >
                <Header isSidebar={isSidebar} setSidebar={setSidebar} />

                <Banner />

                <div className="mt-5 mb-5 newMain">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Live Casino</span>{" "}
                    
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={liveCasinoGames} />
                  </div>
                </div>
                <div className="mt-5 mb-5 newMain">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Latest Games</span>{" "}
                    
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={casinoGames} />
                  </div>
                </div>
               
                <div className="mt-5 mb-5 newMain">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Hot Games</span>{" "}
                    
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={RummyGames} />
                  </div>
                </div>


                <Footer />
              </div>
            </div>
          </div>
        </app-landing-page-new>
      </div>
    </app-root>
  );
};

export default LiveCasino;